import React, {Component} from 'react'
import Field from '../common/Field'
import Validator from '../common/Validator'
import api from '../../source/api'
import Alert from '../common/alert'


export default class ForgottPassword extends Component {

    constructor(props) {
        super(props)
        this.state = {
            fields: {
                password: {value: '', error: '', role: {required: true}},
                password_confirmation: {value: '', error: '', role: {required: true}}
            },
            token: props.location.match.params.token,
            message: '',
            type: 'success',
            error: false,
        }
    }

    setValue(name, value, error) {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields})
    }

    setMessage = (msg, type) => {
        this.setState({
            type: type,
            message: msg
        })
    }

    submit() {
        let validator = Validator.validate(this.state.fields)
        if (validator.error) {
            this.setState({
                error: validator.error,
                fields: validator.fields
            })
            return;
        }

        if (this.state.fields.password.value != this.state.fields.password_confirmation.value) {
            this.setMessage('Jelszó és jelszó megerősítés nem egyezik.', 'danger')
            return
        }

        let validPassword = /^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
        if (!validPassword.test(this.state.fields.password.value)) {
            this.setMessage('Jelszó minimum 8 karakter hosszú kell legyen, tartalmaznia kell legalább 1 nagybetűt és 1 számot és 1 speciális karaktert.', 'danger')
            return
        }

        if (!this.state.error) {
            this.setState({message: ''})

            let data = {
                password: this.state.fields.password.value,
                password_confirmation: this.state.fields.password_confirmation.value,
                token: this.state.token
            }

            api.post('user/set-password', data)
                .then((response) => {
                    if (response.status === 200) {
                        this.setMessage('Jelszó csere sikeresen megtörtént.', 'success')
                    }
                })
                .catch((err) => {
                    this.setMessage('Hiba történt feldolgozás közben, kérjük lépjen kapcsolatba velünk a következő email címen. info@beeker.hu', 'danger')
                })
        }
    }

    render() {
        return (
            <div className="site-login">
                <h1 className="offset-md-4 col-lg-4 text-center">Új jelszó beállítása</h1>
                <div className="row">
                    <div className="col-lg-4 offset-md-4">
                        {this.state.message ? <Alert type={this.state.type} message={this.state.message}/> : null}
                        <Field
                            type="password"
                            id="password"
                            name="password"
                            label="Jelszó"
                            classLabel="control-label"
                            classInput="form-control"
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                        <Field
                            type="password"
                            id="password_confirmation"
                            name="password_confirmation"
                            label="Jelszó megerősítés"
                            classLabel="control-label"
                            classInput="form-control"
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                        <div className="form-group  text-center">
                            <br/>
                            <button type="submit" onClick={() => this.submit()} className="btn green-btn" name="login-button">Küldés</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/forgottpassword/forgottpassword.js